import React, { Component } from 'react'
import { connect } from 'react-redux'

import LawyerChatAction from '@app/modules/Messages/store/actions'

const chatDocumentHOC = (WrappedComponent) => {
  class Documents extends Component {
    render() {
      const { onAuditSelectedDocRemove, auditReport, onUploadDoc } = this.props
      return (
        <WrappedComponent
          {...this.props}
          onUploadDoc={({ formData, letter }) => onUploadDoc(formData, true, letter)}
          selectedDocuments={auditReport.selectedDocuments}
          selectedLetterId={auditReport.selectedLetterId}
          onSelectedDocRemove={onAuditSelectedDocRemove}
        />
      )
    }
  }

  return connect(({ lawyerChat }) => ({ ...lawyerChat }), {
    onAuditSelectedDocRemove: LawyerChatAction.onAuditSelectedDocRemove,
    onLetterSelectedDocRemove: LawyerChatAction.onRemoveSelectedLetterFromAudit,
    onUploadDoc: LawyerChatAction.onUploadDoc
  })(Documents)
}

export default chatDocumentHOC
